module.exports = __webpack_public_path__ + "static/media/ENCONTRO_6_ED_FISICA.81c2c492.pdf";